import { Tooltip, Typography } from "@mui/material";

import { useAppSelector } from "@/common/hooks";

import { TShiftEditorProps } from "../types";

export const DebugTooltip = (props: TShiftEditorProps) => {
  const { staffShift } = props;

  const devMode = useAppSelector((state) => state.schedulerGrid.grid.filters.devMode);

  if (!devMode) return null;

  return (
    <Tooltip
      componentsProps={{
        tooltip: { className: "shift-editor-dev-mode-tooltip" },
      }}
      title={
        <Typography>
          <pre>{JSON.stringify(staffShift, null, 2)}</pre>
        </Typography>
      }
      arrow
      placement="top"
    >
      <Typography mb={2} children={staffShift.id} />
    </Tooltip>
  );
};
